import React from "react";
import { Bell, ChevronRight, HelpCircle } from "lucide-react";
import { Button } from "../../../components/ui/primitives";

export function Header() {
  return (
    <header className="flex h-16 items-center justify-between">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-3">
          <LogoMark />
          <div className="text-base font-semibold tracking-tight">K-Quant</div>
        </div>

        <nav className="hidden items-center gap-3 md:flex">
          <Button variant="primary" size="sm" className="h-8 px-4">
            Smart Insights
          </Button>
          <NavItem label="Quant flows" />
          <NavItem label="Quant square" />
          <NavItem label="Back testing" />
        </nav>
      </div>

      <div className="flex items-center gap-3">
        <button className="hidden items-center gap-2 text-xs text-white/70 hover:text-white md:flex">
          <HelpCircle className="h-4 w-4" />
          Help center
        </button>
        <Button variant="ghost" size="icon" className="rounded-full">
          <Bell className="h-4 w-4 text-white/70" />
        </Button>
        <div className="grid h-9 w-9 place-items-center rounded-full border border-white/10 bg-white/5 text-sm font-semibold">
          V
        </div>
      </div>
    </header>
  );
}

function NavItem({ label }: { label: string }) {
  return (
    <button className="flex items-center gap-1 rounded-full px-3 py-2 text-xs text-white/70 hover:bg-white/5 hover:text-white">
      {label}
      <ChevronRight className="h-3.5 w-3.5 text-white/40" />
    </button>
  );
}

function LogoMark() {
  return (
    <div className="relative grid h-8 w-8 place-items-center">
      <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-cyan-400/40 to-blue-500/30 blur-[1px]" />
      <div className="relative h-7 w-7 rounded-lg border border-white/10 bg-white/5">
        <div className="absolute left-[10px] top-[7px] h-[14px] w-[2px] bg-cyan-300/80" />
        <div className="absolute left-[13px] top-[7px] h-[14px] w-[2px] bg-blue-400/70" />
        <div className="absolute left-[16px] top-[7px] h-[14px] w-[2px] bg-indigo-400/60" />
      </div>
    </div>
  );
}
